import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { NpsDialogComponent } from './nps-dialog.component';
import { MaterialModule } from 'src/app/material.module';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  declarations: [
    NpsDialogComponent 
  ],
  exports: [
    NpsDialogComponent
  ],
  entryComponents: [
    NpsDialogComponent
  ]
})
export class NpsDialogModule { }
